import { DatePicker, TimePicker } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React from 'react';
import { Clock } from 'react-feather';

interface Props {
  isAdditionalServicesDate?: boolean;
}

const MechanicsRecordFooter: React.FC<Props> = ({
  isAdditionalServicesDate,
}) => {
  const services = [
    'Reaperto',
    'Geometria',
    'Garga de Gás',
    'Sangria',
    'Retifica 2x',
    'Retifica 4x',
  ];

  const details = [
    'P.P.F',
    'Vitrificação',
    'Polimento',
    'Pelicula',
    'Higienização',
    'Oxisanitização',
  ];

  const chemicals = ['Kit Revisão', 'Complete F.S', 'Auto Clear', 'Auto Break'];

  return (
    <div>
      {isAdditionalServicesDate && (
        <table style={{ marginBottom: 8 }}>
          <thead>
            <tr>
              <th>Serviços Adicionais</th>
              <th>Detail S.C.S</th>
              <th>Quimicos</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                {services.map((item, index) => (
                  <label key={index} className="more-services">
                    <input type="checkbox" />
                    <span>{item}</span>
                  </label>
                ))}
              </td>

              <td>
                {details.map((item, index) => (
                  <label key={index} className="more-services">
                    <input type="checkbox" />
                    <span>{item}</span>
                  </label>
                ))}
              </td>

              <td>
                {chemicals.map((item, index) => (
                  <label key={index} className="more-services">
                    <input type="checkbox" />
                    <span>{item}</span>
                  </label>
                ))}
              </td>

              <td className="input-style-print">
                <label style={{ margin: '8px 4px' }}>
                  <span>Mão de Obra:</span>
                  <input type="text" />
                </label>

                <label style={{ margin: '8px 4px' }}>
                  <span>Data:</span>
                  <DatePicker placeholder="" format="DD/MM/YYYY" />
                </label>

                <label style={{ margin: '8px 4px' }}>
                  <span>Hora:</span>
                  <TimePicker
                    placeholder=""
                    suffixIcon={<Clock size={14} />}
                    format="HH:mm"
                  />
                </label>
              </td>
            </tr>
          </tbody>
        </table>
      )}

      <table>
        <thead>
          <tr>
            <th style={{ width: 400 }}>
              PRAZO DE ENTREGA APÓS APROVAÇÃO DO ORÇAMENTO:
            </th>
            <th>
              <TextArea rows={1} />
            </th>
          </tr>
        </thead>
      </table>
    </div>
  );
};

export default MechanicsRecordFooter;
